var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#EDFEF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3375 21.9601C27.1275 21.8551 25.92 21.3751 22.9725 22.5526C21.6975 23.0626 21.1275 22.5526 20.0625 21.3601C18.9975 20.1676 17.55 18.6076 14.76 19.5376C14.611 19.588 14.4817 19.6838 14.3901 19.8117C14.2986 19.9395 14.2496 20.0929 14.25 20.2501V27.0001C14.25 27.1991 14.329 27.3898 14.4697 27.5305C14.6103 27.6711 14.8011 27.7501 15 27.7501H27C27.1989 27.7501 27.3897 27.6711 27.5303 27.5305C27.671 27.3898 27.75 27.1991 27.75 27.0001V22.6276C27.7496 22.4891 27.7108 22.3535 27.638 22.2356C27.5652 22.1178 27.4612 22.0225 27.3375 21.9601ZM22.5 21.0001H23.3775C23.974 20.9996 24.546 20.7622 24.9675 20.3401L26.7825 18.5326C26.8528 18.4629 26.9086 18.38 26.9467 18.2886C26.9847 18.1972 27.0044 18.0991 27.0044 18.0001C27.0044 17.9011 26.9847 17.8031 26.9467 17.7117C26.9086 17.6203 26.8528 17.5374 26.7825 17.4676L26.1825 16.8751L27.5325 15.5326C27.6737 15.3914 27.7531 15.1999 27.7531 15.0001C27.7531 14.8004 27.6737 14.6089 27.5325 14.4676C27.3913 14.3264 27.1997 14.2471 27 14.2471C26.8003 14.2471 26.6087 14.3264 26.4675 14.4676L25.125 15.8176L24.5325 15.2176C24.4628 15.1473 24.3798 15.0915 24.2884 15.0535C24.197 15.0154 24.099 14.9958 24 14.9958C23.901 14.9958 23.803 15.0154 23.7116 15.0535C23.6202 15.0915 23.5372 15.1473 23.4675 15.2176L21.66 17.0326C21.2379 17.4542 21.0005 18.0261 21 18.6226V19.5001C21 19.898 21.158 20.2795 21.4393 20.5608C21.7206 20.8421 22.1022 21.0001 22.5 21.0001Z",
    fill: "#00A852"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMining);
export default __webpack_public_path__ + "static/media/mining.9731354af51e0117ab862f6442b90ea5.svg";
export { ForwardRef as ReactComponent };